var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Chip, Typography } from '@mui/material';
import { ReactComponent as MoreIconSvg } from '../../../assets/images/dots-vertical.svg';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { ContractSaleInvoicePagingAPI } from '../services/apiCall';
import { ContractInvoiceKeys } from '../services/entity';
var InvoicedCatalogueView = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var value = props.value;
    var dispatch = useAppDispatch();
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var moreIconClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var MenuList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Menu',
                        Component: ActionMenuList,
                        containerProps: {
                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                            anchorOrigin: {
                                vertical: 'center',
                                horizontal: 'right'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            }
                        },
                        componentProps: {
                            items: [{
                                    id: 'viewOrder',
                                    children: ["View Invoice"]
                                }, {
                                    id: 'ShareOrder',
                                    children: ["Share Invoice"]
                                }, {
                                    id: 'PrintOrder',
                                    children: ["Print Invoice"]
                                }, {
                                    id: 'ReturnInvoice',
                                    children: ["Return Invoice"]
                                }]
                        }
                    }))];
                case 1:
                    MenuList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var pagingColumns = [{
            field: 'InvoiceNumber.',
            headerName: 'Invoice no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceNumber ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceNumber) : '-'; },
            minWidth: 175
        }, {
            field: 'InvoiceDate',
            headerName: 'Invoice date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.InvoiceDate)) : '-'; }
        }, {
            field: 'OrderNumber',
            headerName: 'Order no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OrderNumber ? "".concat(row === null || row === void 0 ? void 0 : row.OrderNumber) : '-'; },
            minWidth: 175
        }, {
            field: 'OrderDate',
            headerName: 'Order date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OrderDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.OrderDate)) : '-'; }
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 200
        }, {
            field: 'MobileNumber',
            headerName: 'Customer no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.MobileNumber ? "".concat(row === null || row === void 0 ? void 0 : row.MobileNumber) : '-'; },
            minWidth: 200
        }, {
            field: 'InvoiceAmount',
            headerName: 'Invoice amount',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceAmount ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceAmount) : '-'; },
            minWidth: 140
        }, {
            field: 'CurrentOutstanding',
            headerName: 'Outstanding amount',
            // valueFormatter: (val, row) => (row?.CurrentOutstanding ? `${row?.CurrentOutstanding}` : '-'),
            minWidth: 120
        }, {
            field: 'PaymentModeName',
            headerName: 'Payment mode',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PaymentModeName ? "".concat(row === null || row === void 0 ? void 0 : row.PaymentModeName) : '-'; },
            minWidth: 175
        }, {
            field: 'PaymentTypeName',
            headerName: 'Payment method',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PaymentTypeName ? "".concat(row === null || row === void 0 ? void 0 : row.PaymentTypeName) : '-'; },
            minWidth: 175
        }, {
            field: 'PaymentStatus',
            headerName: 'Payment status',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PaymentStatus ? "".concat(row === null || row === void 0 ? void 0 : row.PaymentStatus) : '-'; },
            minWidth: 175
        }, {
            field: 'ExecutiveName',
            headerName: 'Executive',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ExecutiveName ? "".concat(row === null || row === void 0 ? void 0 : row.ExecutiveName) : '-'; },
            minWidth: 175
        }, {
            field: 'CreatedByName',
            headerName: 'Created by',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedByName ? "".concat(row === null || row === void 0 ? void 0 : row.CreatedByName) : '-'; },
            minWidth: 175
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row, _params$row$StatusNam, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    height: '100%'
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.StatusName ? /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$StatusNam = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.StatusName) !== null && _params$row$StatusNam !== void 0 ? _params$row$StatusNam : '-',
                    size: "small",
                    variant: "outlined",
                    id: 'status',
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.StatusName) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                }) : /*#__PURE__*/ React.createElement(Typography, null, '-'));
            },
            minWidth: 120
        }, {
            type: 'actions',
            field: 'actions',
            headerName: 'Action',
            minWidth: 50,
            renderCell: function () {
                return /*#__PURE__*/ React.createElement(MoreIconSvg, {
                    color: "secondary.600",
                    onClick: moreIconClick
                });
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: ContractInvoiceKeys.Paging,
        getPagingData: ContractSaleInvoicePagingAPI,
        pagingAPIRequest: {
            Status: ['Invoiced'],
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        },
        columns: pagingColumns,
        dataGridProps: {
            sx: {
                m: '0px 16px'
            }
        }
    }));
};
export default InvoicedCatalogueView;
